import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CategoryList from "./pages/category";
import CategoryNew from "./pages/categorynew";
import TagList from "./pages/tags";
import TagNew from "./pages/tagsnew";
import Dashboard from "./pages/dashboard";
import PostList from "./pages/post";
import PostNew from "./pages/postnew";
import MediaList from "./pages/media";
import MediaNew from "./pages/medianew";
import UserList from "./pages/user.js";
import LoginPage from './loginpage.js';
import ProtectedRoute from './components/protectedroute.js';
import Questions from './pages/question';
import QuestionNew from './pages/questionnew';
import SubjectList from './pages/subject';
import ISubjectNew from './pages/subjectnew';
import Sitemaps from './pages/sitemap';
import PagesList from './pages/pages';
import PageNew from './pages/pagesnew';

function App() {
  return (
     <>
            <Routes>
                <Route path="/login" element={<LoginPage />}/>
                <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/post" element={<ProtectedRoute><PostList /></ProtectedRoute>} />
                <Route path="/post/add" element={<ProtectedRoute><PostNew /></ProtectedRoute>} />
                <Route path="/category" element={<ProtectedRoute><CategoryList /></ProtectedRoute>} />
                <Route path="/category/add" element={<ProtectedRoute><CategoryNew /></ProtectedRoute>} />
                <Route path="/media" element={<ProtectedRoute><MediaList /></ProtectedRoute>} />
                <Route path="/media/add" element={<ProtectedRoute><MediaNew /></ProtectedRoute>} />
                <Route path="/user" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
                <Route path="/tags" element={<ProtectedRoute><TagList /></ProtectedRoute>} />
                <Route path="/tags/add" element={<ProtectedRoute><TagNew /></ProtectedRoute>} />
                <Route path="/subject" element={<ProtectedRoute><SubjectList /></ProtectedRoute>} />
                <Route path="/subject/add" element={<ProtectedRoute><ISubjectNew /></ProtectedRoute>} />
                <Route path="/question" element={<ProtectedRoute><Questions /></ProtectedRoute>} />
                <Route path="/question/add" element={<ProtectedRoute><QuestionNew /></ProtectedRoute>} />
                <Route path="/pages" element={<ProtectedRoute><PagesList /></ProtectedRoute>} />
                <Route path="/page/add" element={<ProtectedRoute><PageNew /></ProtectedRoute>} />
                <Route path="/sitemap" element={<Sitemaps />} />
            </Routes>
        </>
  );
}

export default App;
